"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _q = _interopRequireDefault(require("q"));

var _offerBuilderApi = _interopRequireDefault(require("self-service-api/core/api/offerBuilderApi"));

var _quantityUpgradesApi = _interopRequireDefault(require("self-service-api/core/api/quantityUpgradesApi"));

var _createOfferPayload = require("self-service-api/core/utilities/createOfferPayload");

var _createQuantityUpgradesPayload = require("self-service-api/core/utilities/createQuantityUpgradesPayload");

var _validators = require("self-service-api/core/validators");

var MerchandiseIdLists = _interopRequireWildcard(require("self-service-api/constants/MerchandiseIdLists"));

var _MerchandiseIds = require("self-service-api/constants/MerchandiseIds");

var _getIsProductOwned = require("self-service-api/api/getIsProductOwned");

var isQuantityMerchId = function isQuantityMerchId(merchandiseId) {
  return MerchandiseIdLists.QUANTITY_MERCHANDISE_IDS.indexOf(merchandiseId) !== -1;
};

var getIsQuantityUpgrade = function getIsQuantityUpgrade(_ref) {
  var itemConfigurations = _ref.itemConfigurations;

  if (!itemConfigurations || !itemConfigurations.length) {
    return _q.default.Promise.resolve(false);
  }

  var isQuantityUpgradePromises = itemConfigurations.map(function (_ref2) {
    var merchandiseId = _ref2.merchandiseId;

    // Add special case for sales starter and sales pro legacy additional seat purchase
    if (merchandiseId === _MerchandiseIds.PRODUCT_SALES_STARTER) {
      return (0, _getIsProductOwned.getIsProductOwned)(_MerchandiseIds.PRODUCT_SALES_STARTER);
    }

    if (merchandiseId === _MerchandiseIds.PRODUCT_SALES_PRO_LEGACY) {
      return (0, _getIsProductOwned.getIsProductOwned)(_MerchandiseIds.PRODUCT_SALES_PRO_LEGACY);
    }

    if (merchandiseId === _MerchandiseIds.PRODUCT_SALES_PRO_BUSINESS_USER) {
      return (0, _getIsProductOwned.getIsProductOwned)(_MerchandiseIds.PRODUCT_SALES_PRO_BUSINESS_USER);
    }

    return _q.default.Promise.resolve(isQuantityMerchId(merchandiseId));
  });
  return _q.default.Promise.all(isQuantityUpgradePromises).then(function (isQuantityUpgrade) {
    return isQuantityUpgrade.every(function (upgrade) {
      return !!upgrade;
    });
  });
};

var getPurchaseOrderId = function getPurchaseOrderId(purchaseConfig) {
  (0, _validators.validatePurchaseConfig)(purchaseConfig);
  var termId = purchaseConfig.termId,
      currencyCode = purchaseConfig.currencyCode,
      itemConfigurations = purchaseConfig.itemConfigurations,
      productBasedOffers = purchaseConfig.productBasedOffers;
  return getIsQuantityUpgrade(purchaseConfig).then(function (isQuantityUpgrade) {
    if (isQuantityUpgrade) {
      var quantityUpgradesPayload = (0, _createQuantityUpgradesPayload.createQuantityUpgradesPayload)(itemConfigurations);
      return _quantityUpgradesApi.default.post(quantityUpgradesPayload);
    }

    var offerPayload = (0, _createOfferPayload.createOfferPayload)({
      termId: termId,
      itemConfigurations: itemConfigurations,
      productBasedOffers: productBasedOffers
    });
    return _offerBuilderApi.default.put({
      currencyCode: currencyCode,
      offerPayload: offerPayload
    }).then(function (response) {
      return response.id;
    });
  });
};

var _default = getPurchaseOrderId;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.1360/js/api/getPurchaseOrderId.js
// module id = 718
// module chunks = 5 6